const PurchaseType = {
  PRODUCT: 'PRODUCT',
  SUBSCRIPTION: 'SUBSCRIPTION',
};

export default PurchaseType;